export default __webpack_public_path__ + "static/media/spaghetti-dish.63565e8b.jpg";